interface SpectrumTier { id: string; label: string }

export default function GradientSpectrum({ tiers, placementId, tooltip }: { tiers: SpectrumTier[]; placementId: string; tooltip?: string | null }) {
  const index = Math.max(0, tiers.findIndex((t) => t.id === placementId));
  const percent = tiers.length > 1 ? (index / (tiers.length - 1)) * 100 : 0;

  return (
    <div>
      <div className="relative mb-8">
        {/* Labels above (even indices) */}
        <div className="mb-2 flex justify-between gap-1 text-[11px] font-medium uppercase tracking-[0.2em] text-slate-600">
          {tiers.map((t, i) => (
            i % 2 === 0 && (
              <span 
                key={t.id} 
                className={`leading-4 break-words ${
                  i === 0 ? 'text-left' : 
                  i === tiers.length - 1 ? 'text-right' : 
                  'text-center'
                }`}
                style={{ 
                  flex: '1 1 0',
                  minWidth: 0
                }}
                title={t.label}
              >
                {t.label}
              </span>
            )
          ))}
        </div>
        
        {/* Gradient bar (rounded track) with free-floating indicator to avoid clipping */}
        <div className="relative h-3.5 w-full" aria-hidden>
          <div
            className="absolute inset-0 rounded-full"
            style={{
              backgroundImage:
                'linear-gradient(90deg, var(--color-primary), color-mix(in oklch, var(--color-primary) 60%, var(--color-secondary)), var(--color-secondary), var(--color-accent))',
              backgroundColor: 'var(--color-base-200)'
            }}
          />
          <div
            className="pointer-events-none absolute inset-0 rounded-full"
            style={{ backgroundImage: 'repeating-linear-gradient(90deg, rgba(255,255,255,0.28) 0 1px, transparent 1px 20px)' }}
          />
          <div
            className="absolute top-1/2 h-4 w-4 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white shadow z-10"
            style={{ left: `${percent}%`, backgroundColor: 'var(--color-primary)' }}
            title={tooltip ?? undefined}
          />
        </div>
        
        {/* Labels below (odd indices) */}
        <div className="mt-2 flex justify-between gap-1 text-[11px] font-medium uppercase tracking-[0.2em] text-slate-600">
          {tiers.map((t, i) => (
            i % 2 !== 0 && (
              <span 
                key={t.id} 
                className={`leading-4 break-words ${
                  i === 0 ? 'text-left' : 
                  i === tiers.length - 1 ? 'text-right' : 
                  'text-center'
                }`}
                style={{ 
                  flex: '1 1 0',
                  minWidth: 0
                }}
                title={t.label}
              >
                {t.label}
              </span>
            )
          ))}
        </div>
      </div>
    </div>
  );
}
